import styled from "styled-components";
import { Box } from "@mui/material";

export const InvitationEntrancePickerContainer = styled(Box)`
	display: flex;
	align-items: center;
	gap: 2px;

	.scroller {
		display: flex;
		flex: 1;
		min-width: 0;
		gap: 16px;
		padding: 8px 4px;
		overflow-x: auto;
		overflow-y: hidden;
		scrollbar-width: none;
		scroll-behavior: smooth;
		&::-webkit-scrollbar {
			display: none;
		}
	}

	.scroll-arrow {
		flex-shrink: 0;
		display: grid;
		place-items: center;
		width: 22px;
		height: 22px;
		padding: 0;
		border: 0;
		border-radius: 50%;
		cursor: pointer;
		color: #fff;
		background: rgba(255, 255, 255, 0.18);
		opacity: 0;
		pointer-events: none;
		transition:
			opacity 0.2s ease,
			background 0.2s ease;

		svg {
			font-size: 18px;
		}
		&.visible {
			opacity: 1;
			pointer-events: auto;
		}
		&:hover {
			background: rgba(255, 255, 255, 0.32);
		}
	}

	.entrance-option {
		flex-shrink: 0;
		padding: 4px 10px;
		font-family: var(--poppins), sans-serif;
		font-size: 12px;
		color: #fff;
		border-radius: 4px;
		cursor: pointer;
		user-select: none;
		opacity: 0.7;
		transition: opacity 0.2s ease;
	}

	.outlined {
		opacity: 1;
		outline: 2px solid #799dbc;
		outline-offset: 2px;
	}
`;
